// extracted by mini-css-extract-plugin
export default {"overdue-books":"OverDueBooks_overdue-books__r8djy"};